import classNames from 'classnames';
import React from 'react';

interface AddSeriesTitleProps {
  title: string;
  className?: string;
}

const AddSeriesTitle: React.FC<AddSeriesTitleProps> = ({ title, className }) => {
  const classname = classNames('add-series-title', className);

  return <h1 className={classname}>{title}</h1>;
};

export default AddSeriesTitle;
